// The words @foodamigos/ui's chat parts show or read out, which the package has in English only (their `labels`
// props, 0.3.0); usePlatformAgentLabels hands them to each part.
export default {
  composer: {
    send: 'Senden',
    stop: 'Stopp',
    attach: 'Dateien anhängen',
    add: 'Hinzufügen',
    upload_files: 'Dateien hochladen',
  },
  attachment: {
    uploading: 'Wird hochgeladen: {{percent}} %',
    uploading_file: '{{name}} wird hochgeladen',
    retry: 'Erneut versuchen',
    remove: '{{name}} entfernen',
    cancel: 'Hochladen von {{name}} abbrechen',
  },
  // What screen readers hear for each step's state, and the collapsed list's line ("4 steps · 1 failed and was retried").
  steps: {
    pending: 'Wartet',
    running: 'Läuft',
    done: 'Erledigt',
    failed: 'Fehlgeschlagen',
    denied: 'Abgelehnt',
    background: 'Im Hintergrund',
    summary_one: '{{count}} Schritt',
    summary_other: '{{count}} Schritte',
    failed_count_one: '{{count}} fehlgeschlagen',
    failed_count_other: '{{count}} fehlgeschlagen',
    retried_one: '{{count}} fehlgeschlagen und erneut versucht',
    retried_other: '{{count}} fehlgeschlagen und erneut versucht',
  },
  question: {
    suggested: 'Vorgeschlagen',
    withdrawn: 'Nicht mehr nötig',
  },
  thread: {
    live_on: 'Live auf {{domain}}',
    unread_one: '{{count}} neu',
    unread_other: '{{count}} neu',
    working: 'Wird bearbeitet',
  },
  // What screen readers hear for each row of a list that needs a look.
  checklist: {
    done: 'Erledigt',
    running: 'In Arbeit',
    waiting: 'Braucht deine Aufmerksamkeit',
    failed: 'Fehlgeschlagen',
    pending: 'Noch nicht',
    skipped: 'Übersprungen',
  },
  lightbox: {
    enlarge: 'Vergrößern: {{label}}',
    close: 'Schließen',
  },
};
